import type { EventBusKey } from '@vueuse/core'

export const appEventKey: EventBusKey<string> = Symbol('symbol-key')